define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ApplicantTypeDomain = void 0;
    class ApplicantTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: ApplicantTypeDomain.Owner, value: "Owner" },
                    { key: ApplicantTypeDomain.Drover, value: "Drover" },
                    { key: ApplicantTypeDomain.Applicant, value: "Applicant" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[ApplicantTypeDomain.Owner] = 0;
                this.KeyIndex[ApplicantTypeDomain.Drover] = 1;
                this.KeyIndex[ApplicantTypeDomain.Applicant] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Owner"] = 0;
                this.ValueIndex["Drover"] = 1;
                this.ValueIndex["Applicant"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.ApplicantTypeDomain = ApplicantTypeDomain;
    Object.defineProperty(ApplicantTypeDomain, "Owner", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(ApplicantTypeDomain, "Drover", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(ApplicantTypeDomain, "Applicant", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(ApplicantTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
